import { observable, action, computed } from 'mobx';
import axios from '../lib/axios';

class FaqStore {
  @observable searchTerm;
  @observable searching = false;
  @observable sections = [];
  @observable selectedSection;
  @observable hasNoFaqs;
  @observable faqId;
  @observable productId;
  loaded = false;

  @action setFaqId(faqId) {
    this.faqId = faqId === undefined ? undefined : parseInt(faqId);
  }

  @action search(searchTerm) {
    this.searchTerm = searchTerm;
    this.searching = true;
    this.productId = undefined;
    axios.get(`/faqs/${this.selectedSection.id}?q=${this.searchTerm}`)
      .then((result) => {
        this.selectedSection.faqs = result.data;
        this.searching = false;
      })
      .catch((error) => {
        this.searching = false;
      })
  }

  @action selectSection(id) {
    const callback = () => {
      this.selectedSection = this.sections.find(s => s.id == id);
      this.hasNoFaqs = this.selectedSection.faqs.length == 0;
    }

    if (!this.loaded)
      this.fetchData(callback);
    else
      callback();
  }

  @action fetchData(callback) {
    axios.get('/faqs')
      .then((result) => {
        this.loaded = true;
        this.sections = result.data;
        if (callback)
          callback();
      })
      .catch((error) => {

      });
  }

  @action filterProducts(productId) {
    this.search('')
    this.productId = productId;
  }

  @action clearFilterProducts() {
    this.productId = undefined;
  }

  @computed get faqs() {
    let data = this.selectedSection.faqs;
    if (this.productId) {
      if (this.faqId) {
        data = data.sort((a, b) => {
          if (b.id === this.faqId)
            return 1;
          return -1;
        });
      }
      return data.filter((faq) => faq.product_id === this.productId)
    }

    return data;
  }
}

export default new FaqStore();



// WEBPACK FOOTER //
// ./src/stores/FaqStore.js